// The arithmetic of swiping a card sideways to show its Delete button (#386),
// kept apart from the pointer handling so it can be tested.

/** How far a finger moves before the swipe decides it is sideways or up-and-down. */
const SWIPE_DECIDE_PX = 10;

/** Sideways (the card follows the finger), up-and-down (left to the page's scroll), or not yet known. */
export type SwipeAxis = 'x' | 'y' | null;

/** Which way a movement of (dx, dy) from the touch's start is going, once it has gone far enough to tell. */
export function swipeAxis(dx: number, dy: number): SwipeAxis {
  if (Math.abs(dx) < SWIPE_DECIDE_PX && Math.abs(dy) < SWIPE_DECIDE_PX) return null;
  return Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
}

/** Where the card sits while dragged: from its start offset, never right of closed or left of fully open. */
export function swipeOffset(start: number, dx: number, width: number): number {
  return Math.min(0, Math.max(-width, start + dx));
}

/** Let go past halfway and it stays open; short of that it springs shut. */
export function swipeSettlesOpen(offset: number, width: number): boolean {
  return offset < -width / 2;
}
